import { STICKY_HEADER_HEIGHT, CONTENT_WRAPPER_ID } from '../../../constants/elements';

export function getFirstVisibleElement() {
  const elements = document.querySelectorAll(`#${CONTENT_WRAPPER_ID} *`);

  for (const element of elements) {
    const rect = element.getBoundingClientRect();

    if (
      rect.height > 0 &&
      rect.top >= STICKY_HEADER_HEIGHT &&
      rect.bottom <= window.innerHeight &&
      element instanceof HTMLElement
    ) {
      return element;
    }
  }

  return null;
}
